import { IconProps } from '../types'

export default function IconInactiveTutorialOn({
    width = '20',
    height = '20',
    className,
}: IconProps) {

    return (
        <svg width={width} height={height} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
            <g filter='url(#filter0_g_7131_5110)'>
                <path fill-rule='evenodd' clip-rule='evenodd' d='M17.5312 9.5625C17.5312 13.9635 13.9635 17.5312 9.5625 17.5312C5.16148 17.5312 1.59375 13.9635 1.59375 9.5625C1.59375 5.16148 5.16148 1.59375 9.5625 1.59375C13.9635 1.59375 17.5312 5.16148 17.5312 9.5625ZM8.9042 13.507C8.6841 13.507 8.50576 13.3286 8.50576 13.1086V8.43604C8.50576 8.21594 8.6841 8.0376 8.9042 8.0376H10.2161C10.4361 8.0376 10.6145 8.21594 10.6145 8.43604V13.1086C10.6145 13.3286 10.4361 13.507 10.2161 13.507H8.9042ZM9.56011 7.0279C9.27491 7.0279 9.03035 6.93366 8.82667 6.7452C8.6229 6.55673 8.52098 6.33006 8.52098 6.06519C8.52098 5.80033 8.6229 5.57365 8.82667 5.38519C9.03035 5.19672 9.27491 5.10249 9.56011 5.10249C9.84794 5.10249 10.0924 5.19672 10.2936 5.38519C10.4973 5.57365 10.5992 5.80033 10.5992 6.06519C10.5992 6.33006 10.4973 6.55673 10.2936 6.7452C10.0924 6.93366 9.84794 7.0279 9.56011 7.0279Z' fill='#5486AC' />
            </g>
            <defs>
                <filter id='filter0_g_7131_5110' x='1.21875' y='1.21875' width='16.6875' height='16.6875' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
                    <feTurbulence type='fractalNoise' baseFrequency='0.1111111119389534 0.1111111119389534' numOctaves='3' seed='6155' />
                    <feDisplacementMap in='shape' scale='0.75' xChannelSelector='R' yChannelSelector='G' result='displacedImage' width='100%' height='100%' />
                    <feMerge result='effect1_texture_7131_5110'>
                        <feMergeNode in='displacedImage' />
                    </feMerge>
                </filter>
            </defs>
        </svg>
    )
}